export const searchSuggestion = {
  "SearchSuggestion.Search.Input": "search-input",
  "ResultGrid.Suggestions.InnerRow": "inner-Row",
  "ResultGrid.SuggestionsRow.ClientName": "client-name",
  "ResultGrid.SuggestionsRow.CellValue": "cell-value",
};
